import React, { useState }from 'react';
import { Grid } from '@mui/material';
import Truncate from 'react-truncate';

import { thousandFormat } from '../../../../Utils/Functions';
import { formatedStyle } from '../../../../Assets/js/constant';

function MiddleTable({ collapsableData, width, depth, setDepth, selectedDepth }) {
  const [opened, setOpened] = useState(depth === 0);

  if (!collapsableData) return <div>No Data</div>;

  let _collapsableData = [];
  const nextDepth = depth + 1;
  let lineNumber = 0;

  let firstWidth = 0;
  let tableWidth = width;
  if (depth === 0) {
    let maxObjectKeyLength = Math.max(...Object.keys(collapsableData).map(key => key.length));
    firstWidth = maxObjectKeyLength * 7;
    tableWidth -= maxObjectKeyLength * 7;
  } else if (depth === 1) {
    let maxObjectKeyLength = Math.max(...Object.keys(collapsableData).map(key => key.length));
    firstWidth = maxObjectKeyLength * 7;
    tableWidth -= maxObjectKeyLength * 7;   
  } else if (depth === 2) {
    firstWidth = width - 237;
  }

  return (
    <Grid container style={{ width: width + 'px' }}>
      {Object.keys(collapsableData).map((key) => {
        _collapsableData = collapsableData[key];
        if (key !== 'opening' && key !== 'closing' && key !== 'last') {
          if (
            collapsableData[key].opening !== 0 ||
            collapsableData[key].closing !== 0
          )
            lineNumber++;
          return (
            <Grid size={12} key={key}>
              {key !== 'null' &&
              (collapsableData[key].opening !== 0 ||
                collapsableData[key].closing !== 0) ? (
                <div
                  className="flex"
                  style={{
                    borderTop:
                      (depth === 0 || lineNumber !== 1) &&
                      'solid 1px #a9a9a9',
                  }}
                >
                  <p
                    onClick={(event) => {
                      if (collapsableData[key].last !== 1) {
                        if (!opened) setDepth(nextDepth);
                        else setDepth(nextDepth - 1);
                        setOpened(!opened);
                      }
                    }}
                    style={{
                      ...formatedStyle(
                        firstWidth,
                        12,
                        0,
                        key === 'Total Liabilities' ? 1 : 0,
                        'pointer',
                      ),
                      paddingTop: 2.575,
                    }}
                    className="grayHover"
                    id={'Colkey' + key}
                  >
                    <Truncate>
                      {key}
                    </Truncate>
                  </p>

                  {(() => {
                    if (
                      collapsableData[key].number &&
                      selectedDepth === 2
                    ) {
                      return (
                        <p
                          style={{
                            ...formatedStyle(
                              43,
                              12,
                              0,
                              key === 'Total Liabilities' ? 1 : 0,
                              'pointer',
                            ),
                            paddingTop: 2.575,
                            textAlign: 'right',
                          }}
                          className="grayHover"
                        >
                          {collapsableData[key].number}
                        </p>
                      );
                    }
                    return null;
                  })()}

                  {(() => {
                    if (
                      collapsableData[key].last === 1 ||
                      !opened
                    ) {
                      return (
                        <div
                          style={{
                            ...formatedStyle(
                              80,
                              12,
                              0,
                              key === 'Total Liabilities' ? 1 : 0,
                              'pointer',
                            ),
                            padding: '2.575px 0',
                            textAlign: 'right',
                            marginLeft: 'auto',
                          }}
                          className="grayHover"
                        >
                          {collapsableData[key].opening > 0
                            ? thousandFormat(collapsableData[key].opening)
                            : `(${thousandFormat(
                                Math.abs(collapsableData[key].opening),
                              )})`}
                        </div>
                      );
                    }
                    return null;
                  })()}

                  {(() => {
                    if (
                      collapsableData[key].last === 1 ||
                      !opened
                    ) {
                      return (
                        <p
                          style={{
                            ...formatedStyle(
                              112,
                              12,
                              0,
                              key === 'Total Liabilities' ? 1 : 0,
                              'pointer',
                            ),
                            padding: '2.575px 0',
                            textAlign: 'right',
                          }}
                          className="grayHover"
                        >
                          {collapsableData[key].closing > 0
                            ? thousandFormat(collapsableData[key].closing)
                            : `(${thousandFormat(
                                Math.abs(collapsableData[key].closing),
                              )})`}
                        </p>
                      );
                    }
                    return (
                      <MiddleTable
                        collapsableData={_collapsableData}
                        width={tableWidth}
                        depth={nextDepth}
                        setDepth={setDepth}
                        selectedDepth={selectedDepth}
                      />
                    );
                  })()}
                </div>
              ) : null}
            </Grid>
          );
        }
        return null;
      })}
    </Grid>
  );
}

export default MiddleTable;
